import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observable, Subject } from "rxjs";
import { result } from "lodash";

@Injectable()
export class DivisionService {
    getEventRoute = "/api/division/";

    route = "/api/dbtstatetarget";
    private sharedData: Subject<any> = new Subject<any>();
    sharedData$: Observable<any> = this.sharedData.asObservable();

    constructor(private dataService: DataService) {
    };

    getSharedData() {
        return this.sharedData;
    }

    getLookUp(refresh: boolean) {
        return this.dataService.getData('/api/division/lookup', refresh);
    }
    getLookUpdivision(refresh: boolean) {
        return this.dataService.getData('/api/division/lookup', refresh);
    }
    getLookUpdivisionnew(financialYearId: number, dbtComponentId: number, dbtProductId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/divisionlookup/' + financialYearId + '/' + dbtComponentId + '/' + dbtProductId, refresh);
    }
    getLookUpbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/division/lookup/' + id, refresh);
    }
    getBlocklist(id: number,refresh: boolean,) {
        return this.dataService.getData('/api/subdivision/allblocklist/' + id, refresh);
    }

    getDistrictByDivision(id: any)
    {
        return this.dataService.getData('/api/lookup/District/'+id,true);
    }

    get(refresh: boolean) {
        return this.dataService.getData('/api/division', refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/division/' + id, refresh);
    }

    getDivisionById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/division/divisionlist/' + id, refresh);
    }

    save(result: any) {
        return this.dataService.post('/api/division/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    stateapprovalsave(result: any) {
        return this.dataService.post('/api/dbtstatetarget/productapprove', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    delete(id: number) {
        return this.dataService.delete('/api/division/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    targetdelete(data: any) {
        return this.dataService.post('/api/dbtstatetarget/targetdelete', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    divisionTargetData(data: any) {
        this.sharedData.next(data);
    }
    getDivisionData() {
        return this.sharedData.asObservable();
    }

    getLookUpPayment(refresh: boolean) {
        return this.dataService.getData('/api/lookup/paymenttype/', refresh);
    }

    getSchemaListbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/dbtstatetarget/dbtschemelist/' + id, refresh);
    }

    getSchemaListbyDeptId(refresh: boolean, deptid: number) {
      return this.dataService.getData('/api/dbtScheme/lookup/' + deptid, refresh);
  }

    getGoListbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/dbtstatetarget/dbtgolist/' + id, refresh);
    }
    getGoById(financialYearId:number,departmentId:number,refresh:boolean) {
        return this.dataService.getData('/api/paccsbooking/dbtgolist/'+financialYearId+'/'+departmentId, refresh);
    }

    getComponetListbyId(goId: number, dbtSchemeId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/dbtcomponentlist/' + goId + '/' + dbtSchemeId, refresh);
    }
    getfilteredComponetListbyId(financialYearId:number,departmentId:number, goId: number, dbtSchemeId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/dbtunmappedcomponentlist/'+ financialYearId + '/'+ departmentId + '/' + goId + '/' + dbtSchemeId, refresh);
    }

    getProductListbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/dbtstatetarget/dbtproductlist/' + id, refresh);
    }

    getfilteredProductList(refresh: boolean, financialYearId: number,departmentId:number, goId: number, dbtSchemeId: number,dbtComponentId: number) {
        return this.dataService.getData('/api/dbtstatetarget/filteredproductlist/' + financialYearId + '/'+ departmentId + '/' + goId + '/' + dbtSchemeId  + '/' + dbtComponentId, refresh);
    }

    getdbtstatetargetmapping(refresh: boolean, financialYearId: number,departmentId:number, goId: number, dbtSchemeId: number,dbtComponentId: number) {
        return this.dataService.getData('/api/dbtstatetarget/dbttarget/' + financialYearId + '/' + departmentId + '/' + goId + '/' + dbtSchemeId  + '/' + dbtComponentId, refresh);
    }


    getProductListSavebyId(financialYearId: number,departmentId:number,  goId: number, dbtSchemeId: number, dbtComponentId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/dbtunmappedproductlist/' + financialYearId +'/' +departmentId + '/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId, refresh);
    }

    getVillagemappedbyId(financialYearId: number, goId: number, dbtSchemeId: number, dbtComponentId: number, subdivision: number, villageId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtvillagetarget/dbtunmappedproductlist/' + financialYearId + '/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + subdivision + '/' + villageId, refresh);
    }

    getSubdivisionmappedbyId(financialYearId: number, goId: number, dbtSchemeId: number, dbtComponentId: number, subDivisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtsubdivisiontarget/dbtunmappedproductlist/' + financialYearId + '/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + subDivisionId, refresh);
    }


    getDivisionmappedbyId(financialYearId: number, goId: number, dbtSchemeId: number, dbtComponentId: number, divisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/dbtunmappedproductlist/' + financialYearId + '/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + divisionId, refresh);
    }
    getSubdivisionListbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/subdivision/lookup/' + id, refresh);
    }
    getvillageListbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/subdivision/villagelookup/' + id, refresh);
    }
    getCommunityType(refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/communitytype', refresh);
    }

    getGenderType(refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/gendertype', refresh);
    }

    getCategoryType(refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/farmertype', refresh);
    }
    showProduct(financialYearId: number,DepartmentId:number, goId: number, dbtSchemeId: number, dbtComponentId: number, dbtProductId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/dbtstatetargetlist/' + financialYearId + '/'+DepartmentId+'/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + dbtProductId, refresh)
    }
    getDivisionTargetData(financialYearId: number,Department:number, goId: number, dbtSchemeId: number, dbtComponentId: number, divisionId: number, dbtProductId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/dbtdivisiontargetlist/' + financialYearId + '/' +Department+'/'+ goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + divisionId + '/' + dbtProductId, refresh)
    }
    getSubDivisionTarget(financialYearId: number,Department:number, goId: number, dbtSchemeId: number, dbtComponentId: number, subDivisionId: number, dbtProductId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtsubdivisiontarget/dbtsubdivisiontargetlist/' + financialYearId + '/' +Department+ '/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + subDivisionId + '/' + dbtProductId, refresh)
    }
    getVillageTarget(financialYearId: number, goId: number, dbtSchemeId: number, dbtComponentId: number, villageId: number, dbtProductId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtvillagetarget/dbtvillagetargetlist/' + financialYearId + '/' + goId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + villageId + '/' + dbtProductId, refresh)
    }

    // /api/dbtvillagetarget/dbtvillagetargetlist/{financialYearId}/{dbtSchemeId}/{dbtComponentId}/{villageId}/{dbtProductId}
    // savedata(data: any) {
    //     return this.dataService.post(this.route, data).map(response => {
    //         return response;
    //     });
    // }

    // getdbtstatetarget(financialYearId: number, dbtSchemeId: number, refresh: boolean) {
    //     return this.dataService.getData('/api/dbtstatetarget/statetargetlist/' + financialYearId + '/' + dbtSchemeId, refresh);
    // }
    getdbtstatetarget(financialYearId: number,dbtDepartmentId:number,dbtGoId:number, dbtSchemeId: number,dbtComponentId:number, refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/statetargetlist/' + financialYearId + '/' +dbtDepartmentId+'/'+ dbtGoId+'/'+ dbtSchemeId + '/' + dbtComponentId, refresh);
    }
    savedata(result: any, refresh: boolean) {
        return this.dataService.post('/api/dbtstatetarget', result).map(response => {
            return response;
        });
    }
    senddata(result: any, refresh: boolean) {
        return this.dataService.post('/api/dbtdivisiontarget/listsave', result).map(response => {
            return response;
        });
    }
    division(financialYearId: number,departmentId:number, dbtGoId: number, dbtSchemeId: number, dbtComponentId: number, dbtProductId: number,refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/statetarget/' + financialYearId + '/'+ departmentId + '/' + dbtGoId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + dbtProductId, refresh)
    }
    village(financialYearId: number, dbtGoId: number, dbtSchemeId: number, dbtComponentId: number, dbtProductId: number, subDivisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtsubdivisiontarget/subdivisiontarget/' + financialYearId + '/' + dbtGoId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + dbtProductId + '/' + subDivisionId, refresh)
    }
    subdivision(financialYearId: number, dbtGoId: number, dbtSchemeId: number, dbtComponentId: number, dbtProductId: number, DivisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/divisiontarget/' + financialYearId + '/' + dbtGoId + '/' + dbtSchemeId + '/' + dbtComponentId + '/' + dbtProductId + '/' + DivisionId, refresh)

    }
    mappingdiv(financialYearId: number, dbtComponentId: number, divisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/dbtunmappedproductlist/' + financialYearId + '/' + dbtComponentId + '/' + divisionId + '/', refresh)
    }

    editTableDivision(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/divisiontargetbyproduct/' + data.financialYearId + '/'+data.departmentId+ '/'+ data.dbtGoId + '/' + data.dbtSchemeId + '/' + data.dbtComponentId + '/' + data.areaId + '/' + data.dbtProductId, refresh)
    }

    editTableSubDivision(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dbtsubdivisiontarget/subdivisiontargetbyproduct/' + data.financialYearId + '/' + data.dbtGoId + '/' + data.dbtSchemeId + '/' + data.dbtComponentId + '/' + data.areaId + '/' + data.dbtProductId+ '/' + data.departmentId, refresh)
    }

    editTableVillage(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dbtvillagetarget/villagetargetbyproduct/' + data.financialYearId + '/' +data.departmentId + '/' + data.dbtGoId + '/' + data.dbtSchemeId + '/' + data.dbtComponentId + '/' + data.areaId + '/' + data.dbtProductId, refresh)
    }

    savediv(result: any, refresh: boolean) {
        return this.dataService.post('/api/dbtdivisiontarget', result).map(response => {
            return response;
        });
    }

    getUnMappedDivProduct(financialYearId: number, dbtComponentId: number, divisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtdivisiontarget/dbtunmappedproductlist/' + financialYearId + '/' + dbtComponentId + '/' + divisionId, refresh)
    }

    saveSubDiv(result: any, refresh: boolean) {
        return this.dataService.post('/api/dbtsubdivisiontarget', result).map(response => {
            return response;
        });
    }

    saveVillage(result: any, refresh: boolean) {
        return this.dataService.post('/api/dbtvillagetarget', result).map(response => {
            return response;
        });
    }
    gettargetConfig(financialYearId:any,departmentId:any,dbtGoId:any,dbtSchemeId:any,dbtComponentId:any,refresh: boolean) {
        return this.dataService.getData('/api/targetConfig/'+financialYearId+'/'+departmentId+'/'+dbtGoId+'/'+dbtSchemeId+'/'+dbtComponentId, refresh)
    }
 savetargetConfig(result:any) {
    return this.dataService.post('/api/targetConfig', result).map(response => {
        return response;
    });
    }
    getDepartmentList(){

    }
    getfilteredPaacsProductList(manufacturerType,machinaryCategoryId,refresh: boolean) {
        return this.dataService.getData('/api/paccsbooking/productlist/'+ manufacturerType+ '/' + machinaryCategoryId, refresh);
    }

}
